// @ts-ignore
import colors from "../scss/variables/colors.scss"

export const LuiColor = (color: string) => {
  if (process.env.NODE_ENV !== "production") {
    if (colors[color] === undefined) {
      console.warn("Looks like you're using a LuiColor that does not exist")
    }
  }
  return colors[color]
}
